import { render, staticRenderFns } from "./IconModalViewCollapse.vue?vue&type=template&id=17970820"
import script from "./IconModalViewCollapse.vue?vue&type=script&lang=js"
export * from "./IconModalViewCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports